import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface WhatsAppOrderState {
  isOpen: boolean;
  defaultProduct: string;
  defaultSize: string;
}

interface WhatsAppOrderContextType {
  state: WhatsAppOrderState;
  openModal: (product?: string, size?: string) => void;
  closeModal: () => void;
}

const WhatsAppOrderContext = createContext<WhatsAppOrderContextType | null>(null);

export function WhatsAppOrderProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<WhatsAppOrderState>({
    isOpen: false,
    defaultProduct: "Flower Printed Set",
    defaultSize: "M",
  });

  const openModal = useCallback((product?: string, size?: string) => {
    setState({
      isOpen: true,
      defaultProduct: product || "Flower Printed Set",
      defaultSize: size || "M",
    });
  }, []);

  const closeModal = useCallback(() => {
    setState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <WhatsAppOrderContext.Provider value={{ state, openModal, closeModal }}>
      {children}
    </WhatsAppOrderContext.Provider>
  );
}

export function useWhatsAppOrder() {
  const ctx = useContext(WhatsAppOrderContext);
  if (!ctx) throw new Error("useWhatsAppOrder must be used within WhatsAppOrderProvider");
  return ctx;
}